import React from 'react'
import PropTypes from 'prop-types'

import './SpinnerComponent.scss'

/*
 * We calculate the border width by multiplying it with a magic number.
 * This magic number is the result of dividing the original border width
 * with the default diameter.
 */
const calculateBorderWidth = (diameter) => diameter * 0.005

const SpinnerComponent = ({ diameter, backgroundColor, foregroundColor }) => {
  const borderWidth = `${calculateBorderWidth(diameter)}em`

  return (
    <div
      className="spinner-component"
      style={{
        '--spinner-background-color': backgroundColor,
        '--spinner-border-width': borderWidth,
        '--spinner-diameter': `${diameter}px`,
        '--spinner-foreground-color': foregroundColor,
      }}
    />
  )
}

SpinnerComponent.defaultProps = {
  diameter: 100,
  backgroundColor: '#787878',
  foregroundColor: '#1cc75b',
}

SpinnerComponent.propTypes = {
  diameter: PropTypes.number,
  backgroundColor: PropTypes.string,
  foregroundColor: PropTypes.string,
}

// oxlint-disable-next-line import/no-default-export
export default SpinnerComponent
